"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationController = exports.ConversationActionsContext = exports.ConversationContext = void 0;
const Comment_1 = __importDefault(require("@opsbase/lib-conversation/Comment"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const ActivityType_1 = __importDefault(require("@opsbase/lib-issue/ActivityType"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const mutations_1 = require("./mutations");
const types_1 = require("./types");
const getKey = (item) => {
    var _a;
    const date = (_a = item.commentDate) !== null && _a !== void 0 ? _a : item.activityDate;
    return `${item.staffId}_${(0, moment_timezone_1.default)(date).fromNow()}`;
};
exports.ConversationContext = react_1.default.createContext(null);
exports.ConversationActionsContext = react_1.default.createContext(null);
const defaultSupportedTimelineStates = [
    types_1.TimelineViewState.MessagesOnly,
    types_1.TimelineViewState.MessagesAndActivity,
    types_1.TimelineViewState.ActivityOnly,
];
function ConversationController({ conversationId: propsConversationId, title, invertLayout, simpleCallouts, relatedOpId, relatedIssueId, editable, children, activity, placeholderText, timezone, timelineState, onCreateConversation, beforeCreateConversation, self, supportedTimelineStates = defaultSupportedTimelineStates, client, onConversationUpdate, customFindConversationQuery, customFindConversationQueryName, onCreateFailed, onUpdateFailed, skipFetch, conversation: propsConversation, refetch: propsRefetch, questionNodeId, }) {
    const [conversationId, setConversationId] = (0, react_1.useState)(propsConversationId);
    const [isSavingMessage, setIsSavingMessage] = (0, react_1.useState)(false);
    const [text, setText] = (0, react_1.useState)('');
    const [shadowStaffId, setShadowStaffId] = (0, react_1.useState)();
    const [editingMessageIndex, setEditingMessageIndex] = (0, react_1.useState)();
    const [timelineViewState, setTimelineViewState] = (0, react_1.useState)(timelineState !== null && timelineState !== void 0 ? timelineState : supportedTimelineStates[0]);
    const [images, setImages] = (0, react_1.useState)();
    const createConversation = (0, react_1.useMemo)(() => (0, mutations_1.getConversationCreate)(client), [client]);
    const addMessageToConversation = (0, react_1.useMemo)(() => (0, mutations_1.getAddMessageToConversation)(client), [client]);
    const { data, refetch: liveRefetch } = (0, mutations_1.useConversationFindById)(client, conversationId, !conversationId || skipFetch, customFindConversationQuery);
    const refetch = (0, react_1.useCallback)(() => (propsRefetch !== null && propsRefetch !== void 0 ? propsRefetch : liveRefetch)(), [liveRefetch, propsRefetch]);
    const [conversation, setConversation] = (0, react_1.useState)(propsConversation !== null && propsConversation !== void 0 ? propsConversation : data === null || data === void 0 ? void 0 : data[customFindConversationQueryName !== null && customFindConversationQueryName !== void 0 ? customFindConversationQueryName : 'findConversationById']);
    (0, react_1.useEffect)(() => {
        const incoming = propsConversation !== null && propsConversation !== void 0 ? propsConversation : data === null || data === void 0 ? void 0 : data[customFindConversationQueryName !== null && customFindConversationQueryName !== void 0 ? customFindConversationQueryName : 'findConversationById'];
        if (incoming && !!conversationId) {
            setConversation(incoming);
        }
        else if (!incoming && !conversationId)
            setConversation(incoming);
    }, [conversationId, customFindConversationQueryName, data, propsConversation]);
    const { messages, participants } = conversation !== null && conversation !== void 0 ? conversation : {};
    const createNewConversation = (0, react_1.useCallback)((comment, photos, staff) => {
        const patch = {
            title: title !== null && title !== void 0 ? title : comment,
            messages: [
                {
                    title: comment,
                    photos,
                    staffId: staff === null || staff === void 0 ? void 0 : staff.id,
                },
            ],
            relatedOp: { id: relatedOpId },
            relatedIssue: { id: relatedIssueId },
        };
        const before = beforeCreateConversation
            ? beforeCreateConversation(comment, photos)
            : Promise.resolve(true);
        return before
            .then(proceed => {
            if (proceed) {
                return createConversation({
                    variables: {
                        patch,
                    },
                });
            }
            throw new Error('could not proceed');
        })
            .then(res => {
            var _a, _b, _c, _d, _e, _f;
            setConversationId((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.createConversation) === null || _b === void 0 ? void 0 : _b.id);
            onCreateConversation === null || onCreateConversation === void 0 ? void 0 : onCreateConversation((_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.createConversation) === null || _d === void 0 ? void 0 : _d.id);
            void (onConversationUpdate === null || onConversationUpdate === void 0 ? void 0 : onConversationUpdate((_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.createConversation));
            if (!customFindConversationQueryName) {
                setConversation((_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.createConversation);
            }
            else {
                refetch();
            }
        })
            .catch(onCreateFailed);
    }, [
        beforeCreateConversation,
        createConversation,
        customFindConversationQueryName,
        onConversationUpdate,
        onCreateConversation,
        onCreateFailed,
        refetch,
        relatedIssueId,
        relatedOpId,
        title,
    ]);
    const handleAddMessage = (0, react_1.useCallback)((comment, photos, staff) => {
        if (comment.length || photos.length) {
            const patch = new Comment_1.default({
                title: comment,
                photos,
                staffId: (staff === null || staff === void 0 ? void 0 : staff.id) || shadowStaffId || self.id,
            });
            return addMessageToConversation({
                variables: {
                    id: conversationId,
                    patch,
                },
            })
                .then(res => { var _a; return onConversationUpdate === null || onConversationUpdate === void 0 ? void 0 : onConversationUpdate((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.addMessageToConversation); })
                .then(() => refetch())
                .catch(onUpdateFailed);
        }
    }, [
        shadowStaffId,
        self,
        addMessageToConversation,
        conversationId,
        onUpdateFailed,
        onConversationUpdate,
        refetch,
    ]);
    const removeMessageFromConversation = (0, react_1.useMemo)(() => (0, mutations_1.getRemoveMessageFromConversation)(client), [client]);
    const deleteMessage = (0, react_1.useCallback)((comment) => {
        removeMessageFromConversation({
            variables: {
                id: conversationId,
                patch: comment,
            },
        })
            .then(res => { var _a; return onConversationUpdate === null || onConversationUpdate === void 0 ? void 0 : onConversationUpdate((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.removeMessageFromConversation); })
            .then(() => refetch())
            .catch(onUpdateFailed);
    }, [
        conversationId,
        onConversationUpdate,
        onUpdateFailed,
        refetch,
        removeMessageFromConversation,
    ]);
    const editMessageInConversation = (0, react_1.useMemo)(() => (0, mutations_1.getEditMessageInConversation)(client), [client]);
    const handleEditMessage = (0, react_1.useCallback)((comment, photos) => {
        if (editingMessageIndex || editingMessageIndex === 0) {
            const c = messages === null || messages === void 0 ? void 0 : messages[editingMessageIndex];
            const patch = new Comment_1.default(Object.assign(Object.assign({}, c), { title: comment, photos }));
            return editMessageInConversation({
                variables: {
                    id: conversationId,
                    patch,
                },
            })
                .then(res => {
                var _a;
                setEditingMessageIndex(undefined);
                return onConversationUpdate === null || onConversationUpdate === void 0 ? void 0 : onConversationUpdate((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.editMessageInConversation);
            })
                .then(() => refetch())
                .catch(onUpdateFailed);
        }
        return Promise.resolve(null);
    }, [
        editingMessageIndex,
        messages,
        editMessageInConversation,
        conversationId,
        onUpdateFailed,
        onConversationUpdate,
        refetch,
    ]);
    const initiateEditMessage = (0, react_1.useCallback)((comment, index) => {
        var _a, _b;
        setEditingMessageIndex(index);
        setText(comment.title);
        setImages((_b = (_a = comment.photos) === null || _a === void 0 ? void 0 : _a.split(',').filter(z => !!z).map(z => ({
            fileName: z,
        }))) !== null && _b !== void 0 ? _b : []);
    }, []);
    const cancelEditMessage = (0, react_1.useCallback)(() => {
        setEditingMessageIndex(null);
        setText('');
        setImages([]);
    }, []);
    const saveMessage = (0, react_1.useCallback)((staff) => {
        if (!text && !(images === null || images === void 0 ? void 0 : images.length))
            return;
        setIsSavingMessage(true);
        const photos = images === null || images === void 0 ? void 0 : images.map(z => z.fileName).join(',');
        if (!conversationId) {
            createNewConversation === null || createNewConversation === void 0 ? void 0 : createNewConversation(text, photos, staff).then(() => setIsSavingMessage(false)).catch(doNothing_1.default);
        }
        else {
            if (editingMessageIndex > -1) {
                handleEditMessage(text, photos)
                    .then(() => setIsSavingMessage(false))
                    .catch(doNothing_1.default);
            }
            else {
                handleAddMessage(text, photos, staff)
                    .then(() => setIsSavingMessage(false))
                    .catch(doNothing_1.default);
            }
        }
        setText('');
        setImages([]);
    }, [
        conversationId,
        createNewConversation,
        editingMessageIndex,
        handleAddMessage,
        handleEditMessage,
        images,
        text,
    ]);
    const cycleTimelineViewState = (0, react_1.useCallback)(() => {
        if (timelineViewState < supportedTimelineStates.length - 1) {
            const newIndex = timelineViewState + 1;
            setTimelineViewState(newIndex);
        }
        else {
            setTimelineViewState(0);
        }
    }, [supportedTimelineStates.length, timelineViewState]);
    const timelineData = (0, react_1.useMemo)(() => {
        var _a;
        const filteredComments = (_a = messages === null || messages === void 0 ? void 0 : messages.filter(z => z)) !== null && _a !== void 0 ? _a : [];
        const filteredTimeline = timelineViewState === types_1.TimelineViewState.MessagesOnly
            ? [...filteredComments]
            : timelineViewState === types_1.TimelineViewState.MessagesAndActivity
                ? [...filteredComments, ...(activity !== null && activity !== void 0 ? activity : [])].filter(z => z.type !== ActivityType_1.default.ADD_COMMENT &&
                    z.type !== ActivityType_1.default.EDIT_COMMENT &&
                    z.type !== ActivityType_1.default.DELETE_COMMENT)
                : [...(activity !== null && activity !== void 0 ? activity : [])];
        const timeline = [...filteredTimeline].sort((a, b) => {
            var _a, _b;
            const aDate = (0, moment_timezone_1.default)((_a = a.commentDate) !== null && _a !== void 0 ? _a : a.activityDate);
            const bDate = (0, moment_timezone_1.default)((_b = b.commentDate) !== null && _b !== void 0 ? _b : b.activityDate);
            if (invertLayout)
                return aDate.isAfter(bDate) ? -1 : aDate.isBefore(bDate) ? 1 : 0;
            return aDate.isAfter(bDate) ? 1 : aDate.isBefore(bDate) ? -1 : 0;
        });
        return timeline === null || timeline === void 0 ? void 0 : timeline.map((timelineItem, idx) => {
            const staff = participants === null || participants === void 0 ? void 0 : participants.find(c => c.id === timelineItem.staffId);
            const isSelf = staff && self && staff.id === self.id;
            const currentKey = getKey(timelineItem);
            const nextKey = timeline.length > idx + 1 ? getKey(timeline[idx + 1]) : null;
            const prevKey = idx > 0 ? getKey(timeline[idx - 1]) : null;
            const firstItem = prevKey !== currentKey;
            const lastItem = currentKey !== nextKey;
            const newData = {
                staff,
                isSelf,
                firstItem,
                lastItem,
            };
            if (timelineItem.commentDate) {
                const comment = new Comment_1.default(timelineItem);
                const commentIndex = timelineViewState === types_1.TimelineViewState.MessagesAndActivity || invertLayout
                    ? messages === null || messages === void 0 ? void 0 : messages.findIndex(z => z.title === comment.title &&
                        z.photos === comment.photos &&
                        z.commentDate === comment.commentDate)
                    : idx;
                return Object.assign(Object.assign({}, newData), { comment, editing: commentIndex === editingMessageIndex, commentIndex });
            }
            else {
                return Object.assign(Object.assign({}, newData), { activity: timelineItem });
            }
        });
    }, [
        activity,
        editingMessageIndex,
        invertLayout,
        messages,
        participants,
        self,
        timelineViewState,
    ]);
    const ctx = (0, react_1.useMemo)(() => {
        return {
            conversationId,
            placeholderText,
            title,
            simpleCallouts,
            relatedOpId,
            relatedIssueId,
            editable,
            timezone,
            timelineViewState,
            timelineData,
            conversation,
            activity,
            text,
            images,
            invertLayout,
            hasActivity: !!activity,
            isSavingMessage,
            editingMessageIndex,
            shadowStaffId,
            loading: !conversation,
        };
    }, [
        activity,
        conversation,
        conversationId,
        editable,
        images,
        invertLayout,
        placeholderText,
        relatedIssueId,
        relatedOpId,
        simpleCallouts,
        text,
        timelineData,
        timelineViewState,
        timezone,
        shadowStaffId,
        title,
        isSavingMessage,
        editingMessageIndex,
    ]);
    const actions = (0, react_1.useMemo)(() => ({
        saveMessage,
        deleteMessage,
        initiateEditMessage,
        cancelEditMessage,
        createNewConversation,
        setTimelineViewState,
        setImages,
        setText,
        setShadowStaffId,
        cycleTimelineViewState,
        setIsSavingMessage,
        refetch,
    }), [
        cancelEditMessage,
        createNewConversation,
        cycleTimelineViewState,
        deleteMessage,
        initiateEditMessage,
        saveMessage,
        refetch,
    ]);
    return (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(exports.ConversationActionsContext.Provider, { value: actions },
            react_1.default.createElement(exports.ConversationContext.Provider, { value: ctx }, children)));
    }, [actions, children, ctx]);
}
exports.ConversationController = ConversationController;
exports.default = ConversationController;
